module.exports = __webpack_public_path__ + "img/logo2.635f0af7.png";